import {InjectionToken} from '@angular/core';

export const defaultErrors = {
  required: () => `پر کردن این فیلد الزامیست.`,
  min: ({min, actual}: any) => `حداقل مقدار مجاز ${min.toLocaleString()} است (مقدار وارد شده: ${actual.toLocaleString()}).`,
  max: ({max, actual}: any) => `حداکثر مقدار مجاز ${max.toLocaleString()} است (مقدار وارد شده: ${actual.toLocaleString()}).`,
  minlength: ({requiredLength}: any) => `حداقل ${requiredLength} کارکتر وارد وارد شود`,
  maxlength: ({requiredLength}: any) => `حداکثر ${requiredLength} کارکتر وارد وارد شود`,
  maxLength: () => `تعداد کارکتر وارد شده بیشتر از مقدار مجاز می باشد`,
  email: () => `ایمیل وارد شده اشتباه است`,
  incorrectMailFormat: () => `فرمت ایمیل اشتباه است.`,
  coefficient: ({coefficientParameter}: any) => `عدد وارد شده باید ضریب ${coefficientParameter} باشد.`,
  incorrectPasswordPattern: () => `پسورد امن نیست. پسورد باید حداقل 8 و حداکثر 32 کاراکتر باشد.`,
  beginWithZero: (prop: any) => `${prop.prop} نباید با 0 شروع شود.`,
  lengthIsDuplicate: () => `طول وارد شده وجود دارد.`,
  certainLength: ({length}: any) => `مقدار وارد شده باید ${length} کارکتر باشد`,
  passwordMatch: (err: any) => `پسورد ها برابر نیستند.`,
  inValidMax: ({max}: any) => `مقدار بیشینه برای این فیلد ${max} می‌باشد.`,
  inValidMin: ({min}: any) => `مقدار کمینه برای این فیلد ${min} می‌باشد.`,
  onlyNumbers: () => `تنها مجاز به نوشتن اعداد هستید`,
  incorrectMobile: () => `فرمت موبایل وارد شده اشتباه است`,
  ineligibleMobile: () => `توانایی احراز هویت اپراتور شما وجود ندارد`,
  pattern: ({message}: any) => message || 'فرمت مقدار وارد شده اشتباه است.',
  areaCode: () => 'کد پیش شماره الزامی است.',
  nationalId: () => 'کد ملی معتبر نیست',
  keywordValidation: () => 'پارامتر باید شامل حرف و عدد باشد. پارامتر نمی‌تواند شامل کلمات کلیدی باشد.',
  incorrectFormat: ({text}: any) => `فرمت ${text} وارد شده اشتباه است.`,
  templateParameterValidation: () => 'قالب باید دارای متغیر (انگلیسی و بدون فاصله در آن) باشد؛ مانند: #contacts#',
  digitsOnly: () => `تنها مجاز به نوشتن اعداد هستید`,
  whitespace: () => 'فرمت مقدار وارد شده اشتباه است.',
  link: ({text}: any) => text || 'فرمت لینک اشتباه است',
  refCodeExists: (error: any) => {
    if (error?.serverError) {
      return 'خطا در ارتباط با سرور. لطفاً دوباره تلاش کنید.';
    }
    return 'این کدمعرف صحیح نیست.';
  },
  invalidCoordinate: () => 'مختصات وارد شده نامعتبر است.',
  minCoordinates: ({requiredLength}: any) => `چندضلعی باید حداقل  ${requiredLength-1} رأس داشته باشد.`,
  maxCoordinates: ({requiredLength}: any) => `حداکثر ${requiredLength} نقطه می‌تواند انتخاب شود.`,
  messengerBotDisplayName: () => 'نام بازو می‌تواند فارسی یا ترکیبی از فارسی و انگلیسی باشد.',
  // Registration admin-reject: style-only; message is shown via smsir-input-hint.
  rejected: () => null,
};

export const FORM_ERRORS = new InjectionToken('FORM_ERRORS', {
  providedIn: 'root',
  factory: () => defaultErrors
});
